@let list = list$ | async;

@if (list?.length > 0 || emptyListKey) {
    <div
        scroll
        (scrollToBottom)="needNextPage$.next(true)"
        class="bazis-infinite-scroll-content"
    >
        <ng-content></ng-content>
        @for (item of list; track item.id) {
            <ng-template
                [ngTemplateOutlet]="itemTpl"
                [ngTemplateOutletContext]="{ item: item }"
            ></ng-template>
        }

        @if (list?.length === 0 && emptyListKey) {
            <div class="bazis-item bh-events-none">
                {{ emptyListKey | transloco }}
            </div>
        }
    </div>
}
